module.exports = __webpack_public_path__ + "static/fourpcpinkfloral3-85db07cc21ed61f923f7a3d636e969bc.jpeg";